import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {httpInterceptorProviders} from './core/interceptadores';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ComponentesModule} from "./core/componentes/componentes.module";
import {ToastrModule} from "ngx-toastr";
import {HttpClientModule} from "@angular/common/http";
import {NgSelectModule} from "@ng-select/ng-select";
import {CommonModule, DATE_PIPE_DEFAULT_OPTIONS, DatePipe} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {registerLocaleData} from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import {NgxMaskDirective, provideNgxMask} from "ngx-mask";
import { MatTooltip } from "@angular/material/tooltip";
import { SecretariaChatComponent } from './modules/secretaria/secretaria-chat/secretaria-chat.component';

registerLocaleData(ptBr, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentesModule,
    BrowserAnimationsModule,
    NgxMaskDirective,
    HttpClientModule,
    CommonModule,
    NgSelectModule,
    MatTooltip,
    SecretariaChatComponent,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 4000,
    }),
  ],
  providers: [provideNgxMask(), httpInterceptorProviders, DatePipe, httpInterceptorProviders, {
    provide: LOCALE_ID,
    useValue: 'pt-BR'
  }, {
    provide: DATE_PIPE_DEFAULT_OPTIONS,
    useValue: { timezone: '-0300' }
  }],
  bootstrap: [AppComponent]
})
export class AppModule {
}
